import React, {useEffect, useRef, useState} from 'react'
import {sha256} from "js-sha256";
import {Input} from "../../../components/Input/Input";

const ResetPassword = (props: { resetPassword: (arg0: boolean) => void; }) => {

    const [username, setUsername] = useState("");
    const [cid, setCID] = useState("");

    const usernameField = useRef<any>(null);
    const cidField = useRef<any>(null);

    useEffect(() => {
        let interval = setInterval(() => {
            if (usernameField.current) {
                setUsername(usernameField.current.value);
                setCID(cidField.current.value);
                //do the same for all autofilled fields
                clearInterval(interval)
            }
        }, 100)
    }, [])

    const onFormSubmit = () => {
        if (!username || !cid)
            console.log('failed login');
        else {

            let url = "";

            url = "https://c.myameego.com/core/login.resetpassword.php?submit&f&username=" + username + "&client_id=" + cid

            // url = "http://localhost/ameego/core/login.resetpassword.php?submit&f&username=" + username + "&client_id=" + cid

            window.location.href=url;
        }
    }

    return (
        <>
            <form className="mt-8" onSubmit={(e) => e.preventDefault()}>

                <div className="-space-y-px rounded-md shadow-sm">
                    <Input id={"username"} name={"username"} type={"text"} label={"Username"} placeholder={"Username"} autoComplete={""} required={true} onChange={setUsername} refObj={usernameField}/>
                    <Input id={"client-id"} name={"client-id"} type={"text"} label={"Client ID"} placeholder={"Client ID"} autoComplete={""} required={true} onChange={setCID} refObj={cidField}/>
                </div>

                <div className="flex items-center justify-between mb-4 mt-4">
                    <div className={"text-sm"}>
                        <a className={"font-medium text-indigo-600 hover:text-indigo-500"}  href="https://support.humi.ca/hc/en-us/requests/new">Submit a Support Ticket</a>
                    </div>
                    <div className="text-sm">
                        <a className="font-medium text-indigo-600 hover:text-indigo-500 cursor-pointer" onClick={() => props.resetPassword(false)}>Know your password? Login!</a>
                    </div>
                </div>

                <div>
                    <button type="submit" className="group relative flex w-full justify-center rounded-md border border-transparent bg-indigo-600 py-2 px-4 text-sm font-medium text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2" onClick={() => onFormSubmit()}>
                      <span className="absolute inset-y-0 left-0 flex items-center pl-3">
                        <svg className="h-5 w-5 text-indigo-500 group-hover:text-indigo-400" xmlns="http://www.w3.org/2000/svg"
                             viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                          <path fill-rule="evenodd"
                                d="M10 1a4.5 4.5 0 00-4.5 4.5V9H5a2 2 0 00-2 2v6a2 2 0 002 2h10a2 2 0 002-2v-6a2 2 0 00-2-2h-.5V5.5A4.5 4.5 0 0010 1zm3 8V5.5a3 3 0 10-6 0V9h6z"
                                clip-rule="evenodd"/>
                        </svg>
                      </span>
                        Reset Password
                    </button>
                </div>
            </form>
        </>
    );
}

export default ResetPassword;